import i18next from 'i18next'
import React from 'react'
import { phoneBlockClasses } from '../../../../../utils/style'
import { getClassName } from '../../../../../utils/utils'
import { useInView } from '../../../../hooks/useInView'
import { ContactItem } from '../../../cmsPageState'
import { InviewOptions } from '../../blocksState'
import { ParsedPhoneNumber } from '../../../../../utils/phoneNumber'

export type PhoneNumbersBlockStyle = Partial<{
  blockSmallClassName: string
  blockBigClassName: string
  inviewClassName: string
  innerClassName: string
  listClassName: string
  itemClassName: string
  linkClassName: string
}>

type PhoneNumbersBlockLayoutProps = {
  index: number
  inview?: InviewOptions
  size: 'large' | 'small'
  contactItems: ContactItem[]
}

export const PhoneNumbersBlockLayout = (props: PhoneNumbersBlockLayoutProps) => {
  const { index, inview, size, contactItems } = props
  const classes = phoneBlockClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("PhoneNumbersBlockLayout inView:", inview),
    !inview?.triggerOnce
  )

  const telephoneItems = contactItems.filter((item): item is ContactItem & { telephone: ParsedPhoneNumber } => !!item.telephone)

  return (
    <address
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(
        phoneBlockClasses,
        size === 'small' ? 'blockSmallClassName' : 'blockBigClassName',
        'container'
      ) + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(phoneBlockClasses, 'innerClassName', '')}>
        {telephoneItems.length > 0 && (
          <ul className={getClassName(phoneBlockClasses, 'listClassName', 'list-unstyled mb-0')}>
            {telephoneItems.map((item) => (
              <li key={`link-${item.description}`} className={getClassName(phoneBlockClasses, 'itemClassName', '')}>
                {size == 'small' && <b aria-hidden="true">{item.description}: </b>}
                <span className="sr-text">{`${i18next.t('common:phoneNumber')} ${item.description}`}</span>
                <a
                  href={item.telephone.uri}
                  className={getClassName(phoneBlockClasses, 'linkClassName', '')}
                  title={i18next.t('common:callOn', { location: item.description })}
                >
                  {item.telephone.formatted}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </address>
  )
}
